import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Menu } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import Flatpickr from './Flatpickr';

interface IProps {
  value: number;
  anchorEl: HTMLElement;
  onSave: (time: number) => void;
  onClose: () => void;
  minDate?: string;
  maxDate?: string;
  enableTime?: boolean;
  enableClear?: boolean;
}

const useStyles = makeStyles(theme => ({
  wrapper: {
    margin: theme.spacing(2),
  },
}));

const DateTime: FC<IProps> = props => {
  const classes = useStyles();
  const { anchorEl, onClose, onSave, value, enableClear, ...flatPickrOptions } = props;
  const { enableTime, minDate, maxDate } = flatPickrOptions;

  const [tempTime, setTempTime] = useState(null);
  const { t } = useTranslation();

  const time = moment.unix(tempTime || value).toDate();
  const options = {
    minDate: minDate || (maxDate ? null : 'today'),
    maxDate,
    inline: true,
    enableTime,
    dateFormat: 'U',
  };

  function handleDateChange(selectedDates: Date[]) {
    const newTime = moment(selectedDates[0]).unix();
    setTempTime(newTime);
  }

  function handleDateSave() {
    onSave(tempTime || value);
  }

  function renderSaveButton() {
    return (
      <Button
        fullWidth
        disabled={!tempTime && !value}
        type="submit"
        size="large"
        variant="contained"
        color="primary"
        onClick={handleDateSave}>
        {t('common:save')}
      </Button>
    );
  }

  function renderSave() {
    return <div className={classes.wrapper}>{renderSaveButton()}</div>;
  }

  function renderClearAndSave() {
    return (
      <div className={classes.wrapper}>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Button onClick={() => onSave(null)}>{t('common:clear')}</Button>
          </Grid>
          <Grid item>{renderSaveButton()}</Grid>
        </Grid>
      </div>
    );
  }

  return (
    <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onClose}>
      <div>
        <Flatpickr value={time} onChange={handleDateChange} options={options} />
        {enableClear ? renderClearAndSave() : renderSave()}
      </div>
    </Menu>
  );
};

DateTime.defaultProps = {
  enableTime: false,
  enableClear: false,
};

export default DateTime;
